// window["runConfig"] = {
//   realm_name: "HarleyDikkinson",
//   keycloak_idp: "https://development.identity.harleydikkinson.com",
//   client_id: "frontend-gaia",
//   platform_header: "GAIA",
//   current_application_id: 23,
//   default_locale: "it-IT",
//   api_endpoint: "https://development.hdhome.it/api",
//   google_api_key: "AIzaSyCQQp8r0Ry3KvmvigYxh1GENBP9St20p-c",
//   SENTRY_AUTH_TOKEN:
//     "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",
// };

let isLocalhost: boolean = false;
if (window.location.href?.includes("localhost") || window.location.href?.includes("development.local")) {
  isLocalhost = true;
}

export const runConfig = {
  realm_name: import.meta.env.VITE_REALM_NAME,
  keycloak_idp: import.meta.env.VITE_KEYCLOAK_IDP,
  client_id: import.meta.env.VITE_CLIENT_ID,
  platform_header: import.meta.env.VITE_PLATFORM_HEADER,
  current_application_id: import.meta.env.VITE_CURRENT_APPLICATION_ID,
  default_locale: import.meta.env.VITE_DEFAULT_LOCALE,
  api_endpoint: import.meta.env.VITE_API_ENDPOINT,
  google_api_key: import.meta.env.VITE_GOOGLE_MAPS_KEY,
  api_prefix: import.meta.env.VITE_API_PREFIX,
  SENTRY_ENABLED: isLocalhost ? false : import.meta.env.VITE_SENTRY_ENABLED,
  SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
} as {
  [key: string]: string | number;
};
